import { ValueConditionObjectType, IValue } from 'src/Types/UrvalTypes';
import { set } from './UrvalConditionObjectUtils';
import { update } from 'ramda';
import { CondOperatorType } from 'src/Types/ClientModelTypes';

export const setValues = <T extends ValueConditionObjectType>(
  newValues: IValue[],
  conditionObject: T
): T => {
  const newCondition = set('values', newValues, conditionObject.condition[0]);
  const newConditions = update(0, newCondition, conditionObject.condition);
  const newConditionObject = set('condition', newConditions, conditionObject);
  return newConditionObject;
};

export const setValueConditionOperator = (
  conditionIndex: number,
  newOperator: CondOperatorType,
  conditionObject: ValueConditionObjectType
): ValueConditionObjectType => {
  const newCondition = set(
    'op',
    newOperator,
    conditionObject.condition[conditionIndex]
  );
  const newConditions = update(
    conditionIndex,
    newCondition,
    conditionObject.condition
  );
  const newConditionObject = set('condition', newConditions, conditionObject);

  return newConditionObject;
};
